<p-dialog
    #dialog
    name="dialog"
    [modal]="true"
    (onShow)="onShow()"
    (onHide)="onHide()"
    [closable]="true"
    [closeOnEscape]="true"
    (keyup.enter)="onEnter($event);"
    [contentStyle]="{'max-height':'570px'}"
    [(visible)]="exibirPopup">

    <p-header>
      <!-- <span class="header-icon">
        <i *ngIf="iconeProduto.mat_icon" class="material-icons">{{iconeProduto.mat_icon}}</i>
        <i *ngIf="iconeProduto.fa_icon" class="{{iconeProduto.fa_icon}}"></i>
      </span> -->
      <span class="header">
        <label class="header-primary">
          {{dadosLinha?.itemProdutoRetiradaPK.produto.descricao}}
        </label>

        <span class="header-secondary">
          <br />
          <label>Solicitado  &nbsp;&nbsp;&nbsp;&nbsp;: {{quantidadeSolicitada}}</label>
          <label [ngClass]="(quantidadeSolicitada !== quantidadeAMover ? 'label-quantidade-a-mover danger' : 'label-quantidade-a-mover')">
            Selecionado : {{quantidadeAMover}}
          </label>
        </span>

      </span>
    </p-header>

    <app-tabela-inventario
      [quantidadeSolicitada]="quantidadeSolicitada"
      #appTabelaInventario></app-tabela-inventario>

    <p-footer>
      <p-button label="Fechar"
                (click)="hide()"
                class="p-button-outlined"
                [disabled]="false"></p-button>

      <p-button label="Aplicar"
                (click)="aplicar()"
                class="p-button-outlined"
                [disabled]="false"></p-button>
    </p-footer>

</p-dialog>
